import React, {memo, useState, useEffect} from 'react';
import theme from './style';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {setSelectedMenu} from '../../redux/actions/states'

import {List, ListItem, ListItemIcon, ListItemText, Collapse} from '@material-ui/core';
import {Home as HomeIcon, Person as PersonIcon} from '@material-ui/icons';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import {useHistory, useParams, withRouter} from "react-router-dom";
import translate from '../../misc/applyTranslation';
import {useConfig} from "../../context/configContext";
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import N8nDashboard from '../n8nDashboard/N8nDashboard';
import N8nUnavailable from '../n8nDashboard/N8nUnavailable';
import n8nEvents from './n8nEvents';

const DrawerMenu = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const {
    setSelectedMenu,
    selectedMenu,
    closeMenu,
    access_token
  } = props;
  const [open, setOpen] = useState(null);
  const [isN8nOpen, setIsN8nOpen] = useState(false);

  const toggleN8n = () => {
    setIsN8nOpen((prev) => !prev);
  };

  const {
    n8nLoading,
    n8nError,
    n8nSections,
    failedJobs,
    latestOpenRun,
    latestFailure,
    openHasMore,
    failedHasMore,
    openNextCursor,
    failedNextCursor,
    refreshN8n,
    lastUpdateTime
  } = n8nEvents({
    isN8nOpen,
    access_token,
  });
  const history = useHistory();
  const params = useParams();

  const lastJobsFailed = n8nSections.lastEventPerJob.some(i => Number(i.status_code) !== 200);
  const n8nHasProblem = Boolean(n8nError) || lastJobsFailed;

  const handleClick = (id) => {
    if (open === id) {
      setOpen(null)
    } else {
      setOpen(id)
    }
  };
  const handleNavigation = (id) => {
    switch (id) {
      case 0:
        history.push(`/${params.lang}`)
        break;
      case 1:
        history.push(`/${params.lang}/customers`)
        break;
      case 2:
        history.push(`/${params.lang}/customers/add-customer`)
        break;
      case 3:
        history.push(`/${params.lang}/supplier-invoices`)
        break;
      case 4:
        history.push(`/${params.lang}/suppliers`)
        break;
      case 5:
        history.push(`/${params.lang}/invoices`)
        break;
      case 6:
        history.push(`/${params.lang}/files`)
        break;
      case 7:
        history.push(`/${params.lang}/invoices/details`);
        break;
      default:
        break;
    }
    setSelectedMenu(id)
    closeMenu();
  }

  useEffect(() => {
    if ((selectedMenu === 1 || selectedMenu === 2)) {
      if (open !== '0') setOpen('0')
    } else if (selectedMenu === 5 || selectedMenu === 7 || selectedMenu === 8) {
      if (open !== '1') setOpen('1')
    } else {
      setOpen(null)
    }
    // eslint-disable-next-line
  }, [selectedMenu])
  return (
    <div className={classes.drawerContainer}>
      <List>

        <ListItem button className={selectedMenu === 0 ? classes.selected : ''} onClick={() => handleNavigation(0)}>
          <ListItemIcon><HomeIcon/> </ListItemIcon>
          <ListItemText primary={translate('', 'menu_home')}/>
        </ListItem>

        <ListItem button
          className={(selectedMenu === 1 || selectedMenu === 2 || open === '0') ? classes.selectedMain : ''}
          onClick={handleClick.bind(null, '0')}>
          <ListItemIcon><PersonIcon/></ListItemIcon>
          <ListItemText primary={translate('', 'menu_customers')}/>
        </ListItem>
        <Collapse in={open === '0'} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button className={`${classes.nested} ${selectedMenu === 1 ? classes.selectedNested : ''}`}
              onClick={() => handleNavigation(1)}>
              <ListItemText primary={translate('', 'menu_search_customers')}/>
            </ListItem>
            <ListItem button className={`${classes.nested} ${selectedMenu === 2 ? classes.selectedNested : ''}`}
              onClick={() => handleNavigation(2)}>
              <ListItemText primary={translate('', 'menu_add_customers')}/>
            </ListItem>
          </List>
        </Collapse>

        <ListItem button className={selectedMenu === 3 ? classes.selected : ''} onClick={() => handleNavigation(3)}>
          <ListItemIcon><img alt='' src={selectedMenu === 3 ? '/box-reverse.png' : "/box.png"}/> </ListItemIcon>
          <ListItemText primary={translate('', 'menu_supplier_invoices')}/>
        </ListItem>


        <ListItem button className={selectedMenu === 4 ? classes.selected : ''} onClick={() => handleNavigation(4)}>
          <ListItemIcon><img alt='' src={selectedMenu === 4 ? '/factory-reverse.png' : "/factory.png"}/> </ListItemIcon>
          <ListItemText primary={translate('', 'menu_suppliers')}/>
        </ListItem>

        <ListItem button
          className={(selectedMenu === 5 || selectedMenu === 7 || selectedMenu === 8 || open === '1') ? classes.selectedMain : ''}
          onClick={handleClick.bind(null, '1')}>
          <ListItemIcon><img alt='' src={selectedMenu === 5 ? '/invoice-reverse.png' : '/invoice.png'}/> </ListItemIcon>
          <ListItemText primary={translate('', 'menu_economy')}/>
        </ListItem>
        <Collapse in={open === '1'} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button className={`${classes.nested} ${selectedMenu === 5 ? classes.selectedNested : ''}`}
              onClick={() => handleNavigation(5)}>
              <ListItemText primary={translate('', 'menu_invoicing')}/>
            </ListItem>
            <ListItem button
              className={`${classes.nested} ${selectedMenu === 7 || selectedMenu === 8 ? classes.selectedNested : ''}`}
              onClick={() => handleNavigation(7)}>
              <ListItemText primary={translate('', 'menu_invoice_details')}/>
            </ListItem>
          </List>
        </Collapse>

        <ListItem button className={selectedMenu === 6 ? classes.selected : ''} onClick={() => handleNavigation(6)}>
          <ListItemIcon><InsertDriveFileIcon/> </ListItemIcon>
          <ListItemText primary={translate('', 'menu_files')}/>
        </ListItem>
      </List>

      <div className={classes.bottomMenu}>
        <ListItem button className={isN8nOpen ? classes.n8nButtonOpen : classes.n8nButton} onClick={toggleN8n}>
          <ListItemIcon>
            <FiberManualRecordIcon
              className={
                n8nHasProblem
                  ? classes.errorStatusIcon
                  : classes.successStatusIcon
              }
            />
          </ListItemIcon>
          <ListItemText primary={translate('n8n', 'menu_n8n_status')} />
          <ListItemIcon>
            {isN8nOpen ? <ExpandMoreIcon/> : <ExpandLessIcon/>}
          </ListItemIcon>
        </ListItem>
      </div>

      {isN8nOpen && <div className={classes.n8nBackdrop} onClick={toggleN8n}/>}

      <div className={isN8nOpen ? classes.n8nSheetOpen : classes.n8nSheet}>
        {n8nLoading && (
          <List>
            <ListItem>
              <ListItemText primary="Loading..."/>
            </ListItem>
          </List>
        )}

        {n8nError && (
          <N8nUnavailable
            classes={classes}
            error={n8nError}
            retry={refreshN8n}
            loading={n8nLoading}
          />
        )}

        {!n8nLoading && !n8nError && (
          <N8nDashboard
            classes={classes}
            n8nSections={n8nSections}
            failedJobs={failedJobs}
            latestFailure={latestFailure}
            latestOpenRun={latestOpenRun}
            openHasMore={openHasMore}
            failedHasMore={failedHasMore}
            openNextCursor={openNextCursor}
            failedNextCursor={failedNextCursor}
            isN8nOpen={isN8nOpen}
            refreshN8n={refreshN8n}
            lastUpdateTime={lastUpdateTime}
          />
        )}
      </div>
    </div>
  )
}
DrawerMenu.propTypes = {
  setSelectedMenu: PropTypes.func.isRequired,
  closeMenu: PropTypes.func.isRequired,
  selectedMenu: PropTypes.number.isRequired,
}
const mapStateToProps = store => ({
  selectedMenu: store.state.selectedMenu,
  access_token: store.login.access_token,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({setSelectedMenu}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(memo(DrawerMenu)));
